import { registerComponent } from '@gig/magic-common';
import BlockManagerComponent from './block-manager';

export const BlockManager = registerComponent(BlockManagerComponent);
